import React from 'react'

const ViewDoc = () => {
  return (
    <div>ViewDoc</div>
  )
}

export default ViewDoc